import cn from 'classnames';
import { HTMLAttributes } from 'react';

import { ITabsZero, TabType } from './';

export function TabItem(props: ITabsZero & HTMLAttributes<HTMLElement>) {
  const { className, title, index, active, type, onClick } = props;

  const typeClasses: Record<TabType, string> = {
    light: 'text-grey-80',
    dark: 'text-white',
  };

  return (
    <button
      key={index}
      className={cn(
        className,
        'py-2 transition-colors duration-300 text-size7 font-bold relative tracking-tightS',
        active ? typeClasses[type] : 'text-grey-60',
      )}
      onClick={onClick}
    >
      {title}
      <span
        className={cn(
          'absolute bottom-0 left-[50%] ml-[-4px] w-[8px] h-[8px] rounded-full border-2 duration-300',
          active ? 'border-50' : 'border-transparent',
        )}
      ></span>
    </button>
  );
}
